module.exports = __webpack_public_path__ + "img/pr-wed.b6040ecb.png";